import { useEffect, useState } from "react";
import React from "react";
import Preloader from "../../helper/Preloader";
import HeaderTwo from "../HeaderTwo";
import NewsletterTwo from "../NewsletterTwo";
import FooterTwo from "../FooterTwo";
import BottomFooter from "../BottomFooter";
import ColorInit from "../../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import { api } from "../../include/api";
import { useCart } from "../context/UserCartCountContext";

const Layout = (props) => {
  const { fetchCartCount, fetchWishlistCount } = useCart();
  const [categoryList, setCategoryList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [fetchLoading, setFetchLoading] = useState(true);

  useEffect(() => {
    getCategory();
    getBrand();
  }, []);

  const getCategory = () => {
    setFetchLoading(true);
    api
      .get("/category/?parentId=0")
      .then((response) => {
        if (response.status === 200) {
          setCategoryList(
            response.data.data.filter((cl) => cl.name !== "Home"),
          );
        }
      })
      .catch((error) => {
        setCategoryList([]);
      })
      .finally(() => setFetchLoading(false));
  };
  
  const getBrand = () => {
    setFetchLoading(true);
    api
      .get("/category/?parentId=-1")
      .then((response) => {
        if (response.status === 200) {
          setBrandList(response.data.data.filter((cl) => cl.name !== "Home"));
        }
      })
      .catch((error) => {
        setBrandList([]);
      })
      .finally(() => setFetchLoading(false));
  };

  return (
    <main style={{ marginTop: "160px" }}>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */}
      <HeaderTwo
        category={true}
        categoryList={categoryList}
        fetchCartCount={fetchCartCount}
        fetchWishlistCount={fetchWishlistCount}
      />

      {React.Children.map(props.children, (child) =>
        React.isValidElement(child)
          ? React.cloneElement(child, { categoryList, brandList })
          : child,
      )}

      {/* NewsletterTwo */}
      <NewsletterTwo />

      {/* FooterTwo */}
      <FooterTwo />

      {/* BottomFooter */}
      <BottomFooter />
    </main>
  );
};
export default Layout;